import MAV from '@/api/mav';

const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const submitFeedback = async feedbackData => {
  try {
    const payload = {
      request_id: feedbackData.request_id || generateUUID(),
      input_string: feedbackData.input_string,
      ai_suggestion: feedbackData.ai_suggestion,
      user_final_decision: feedbackData.user_final_decision,
      action: feedbackData.action,
    };

    const response = await MAV.post('/feedback', payload);
    return response.data;
  } catch (error) {
    console.error('Feedback API error:', error);
    throw error;
  }
};
